import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import { CloseIcon } from '../../theme/components'
import { Text } from 'rebass'

const Wrapper = styled.div`
  width: 100%;
  padding: 1rem;
`

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`

const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const QRCode = styled.img`
  width: 100%;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 8px 8px 0 0;
`

const EmailText = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.text1};
  text-align: center;
  margin-bottom: 0.5rem;
`

const CopyButton = styled.button`
  background-color: ${({ theme }) => theme.primary1};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.primary2};
  }

  &:active {
    transform: translateY(1px);
  }
`

interface ContactUsModalProps {
  isOpen: boolean
  onDismiss: () => void
}

export default function ContactUsModal({ isOpen, onDismiss }: ContactUsModalProps) {
  const { t } = useTranslation()
  const email = process.env.REACT_APP_CONTACT_EMAIL || 'linksaykchain@gmail.com'

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(email)
      // 可以在这里添加复制成功的提示
    } catch (err) {
      console.error('Failed to copy email:', err)
    }
  }

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <Wrapper>
        <HeaderRow>
          <Text fontWeight={500} fontSize={20}>
            {t('contactUs')}
          </Text>
          <CloseIcon onClick={onDismiss} />
        </HeaderRow>
        <ContentWrapper>
          <QRCodeWrapper>
            <QRCode src={process.env.REACT_APP_QR_CODE_URL || ''} alt="QR Code" />
          </QRCodeWrapper>
          <EmailText>{t('contactEmail', { email })}</EmailText>
          <CopyButton onClick={copyToClipboard}>{t('clickToCopy')}</CopyButton>
        </ContentWrapper>
      </Wrapper>
    </Modal>
  )
}
